function Container({ children, className = "" }) {
  return (
    <div className={`mx-auto w-full max-w-7xl px-5 sm:px-6 lg:px-10 ${className}`.trim()}>
      {children}
    </div>
  );
}

export default Container;
